import { createSelector } from 'reselect';

export function fetchSelector(state) {
  return state.fetch;
}

export function makeFetchEntityByIdSelector(id) {
  return createSelector(fetchSelector, (fetch) => fetch[id] || {});
}
